import './PortProductDetailPage.css'
import 'antd/dist/reset.css'
import React from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import { ConfigProvider, Button, Space, Tag, Drawer, List, Image } from 'antd'
import zhCN from 'antd/es/locale/zh_CN' // 引入中文语言包
import { ArrowUpOutlined } from '@ant-design/icons'
import PortBottomLayout from '../common/PortBottomLayout'
import {
  products,
  getProductByPid,
  getVarietyByVid,
  getProductsOfVariety,
} from '../../products/ProductProvider'

export default class PortProductDetailPage extends React.Component {
  constructor(props) {
    super(props)
    const [pid, product, vid, variety, dataSource, initialPositionItem] =
      this.geInitialStateParams(this.props.location.search)
    this.state = {
      pid: pid,
      product: product,
      vid: vid,
      variety: variety,
      dataSource: dataSource,
      initialPositionItem: initialPositionItem,
    }
    this.productRefs = this.getProductRefs()
  }

  componentDidMount() {
    window.scrollTo(0, 0)
  }

  componentWillReceiveProps = async (nextProps) => {
    if (this.props.location.search !== nextProps.location.search) {
      const [pid, product, vid, variety, dataSource, initialPositionItem] =
        this.geInitialStateParams(nextProps.location.search)
      this.state = {
        pid: pid,
        product: product,
        vid: vid,
        variety: variety,
        dataSource: dataSource,
        initialPositionItem: initialPositionItem,
        listShown: false,
      }
      return true
    }
  }

  render() {
    return (
      <div>
        <div className="PortProductDetail">
          <div className="PortProductDetailHeader">
            <div className="PortProductDetailName">
              {this.state.product.name}
            </div>

            {this.state.product.purchasable ? (
              <Button
                color="blue"
                variant="outlined"
                size="small"
                onClick={this.gotoShop}
                style={{ fontSize: 13, fontFamily: 'MyCustomizedFont' }}
              >
                立即购买
              </Button>
            ) : (
              <Button
                color="pink"
                variant="filled"
                size="small"
                style={{ fontSize: 13, fontFamily: 'MyCustomizedFont' }}
                onClick={this.viewContact}
              >
                咨询购买
              </Button>
            )}
          </div>

          <div className="PortProductDetailWrapper">
            <img
              className="PortProductDetailImage"
              src={this.state.product.picture}
            />

            {this.state.product.specialized ? (
              <Space className="PortProductDetailTags" size={'small'}>
                {this.state.product.specialized.map((tag) => {
                  return (
                    <Tag
                      color="#108ee9"
                      style={{
                        paddingLeft: 6,
                        paddingRight: 6,
                        paddingTop: 4,
                        paddingBottom: 4,
                        fontSize: 10,
                      }}
                    >
                      {tag}
                    </Tag>
                  )
                })}
              </Space>
            ) : null}

            <div className="PortProductDetailText">
              <div className="PortProductDetailFeatureTitle">产品特色</div>

              <div className="PortProductDetailFeatureContent">
                <div className="PortProductDetailFeatureText">
                  {this.state.product.feature}
                </div>
                <div className="PortProductDetailPurchaseHint">
                  {'*如需获取具体产品参数及文档，请联系商务或技术支持'}
                </div>
              </div>
            </div>

            {this.state.product.document ? (
              <div className="PortProductDetailDocumentWrapper">
                <div className="PortProductDetailDocumentTitle">产品说明</div>
                {this.state.product.document.map((paragraph) =>
                  paragraph.type == 'text' ? (
                    <div className="PortProductDetailDocumentText">
                      {paragraph.content}
                    </div>
                  ) : (
                    <ConfigProvider locale={zhCN}>
                      <Image
                        width={400}
                        style={{
                          textAlign: 'start',
                          marginBottom: 30,
                          cursor: 'pointer',
                        }}
                        src={paragraph.src}
                        preview={{ src: paragraph.src, mask: null }}
                      />
                    </ConfigProvider>
                  )
                )}
              </div>
            ) : null}

            <Button
              type="line"
              style={{
                marginTop: 30,
                marginBottom: 50,
                fontSize: 20,
                fontWeight: 'bold',
                textDecoration: 'underline',
                paddingTop: 10,
                paddingBottom: 10,
                fontFamily: 'MyCustomizedFont',
              }}
              icon={<ArrowUpOutlined />}
              iconPosition="end"
              onClick={() => {
                this.setState({ open: true }, () => {
                  if (!this.state.listShown) {
                    if (this.state.initialPositionItem) {
                      var ref = this.getProductRefByPid(
                        this.state.initialPositionItem.pid
                      )
                      if (ref.current) {
                        ref.current.scrollIntoView({})
                      }
                    }
                    this.setState({ listShown: true })
                  }
                })
              }}
            >
              {this.state.variety
                ? '快速查看所有' + this.state.variety.name
                : '快速查看所有产品'}
            </Button>
          </div>
        </div>

        <Drawer
          title={this.state.variety ? this.state.variety.name : '全部产品'}
          placement="bottom"
          open={this.state.open}
          loading={this.state.loading}
          onClose={() => {
            this.setState({ open: false })
          }}
        >
          <div id="productList">
            <InfiniteScroll
              dataLength={this.state.dataSource.length}
              scrollableTarget="productList"
            >
              <List
                dataSource={this.state.dataSource}
                renderItem={(item) => (
                  <List.Item
                    key={item.pid}
                    ref={this.getProductRefByPid(item.pid)}
                    className={
                      item.pid == this.state.product.pid
                        ? 'PortProductDetailListItemSel'
                        : 'PortProductDetailListItemNor'
                    }
                    onClick={() => {
                      this.selectProduct(item)
                    }}
                  >
                    <List.Item.Meta
                      avatar={
                        <img
                          className="PortProductDetailListItemImage"
                          src={item.picture}
                        />
                      }
                      title={
                        <div className="PortProductDetailListItemName">
                          {item.name}
                        </div>
                      }
                    />
                  </List.Item>
                )}
              />
            </InfiniteScroll>
          </div>
        </Drawer>

        <PortBottomLayout {...this.props} />
      </div>
    )
  }

  selectProduct = (product) => {
    var item = this.getScrolledPositionItem(this.state.dataSource, product)
    if (item) {
      var ref = this.getProductRefByPid(item.pid)
      if (ref.current) {
        ref.current.scrollIntoView({ behavior: 'smooth' })
      }
    }
    this.setState({
      pid: product.pid,
      product: product,
    })
  }

  geInitialStateParams = (search) => {
    var i = search.indexOf('pid=')
    var pid = parseInt(search.substring(i + 4, search.length))
    var product = getProductByPid(pid)
    var j = search.indexOf('vid=')
    var vid = j >= 0 ? parseInt(search.substring(j + 4, search.length)) : -1
    var variety = getVarietyByVid(vid)
    var dataSource = variety ? getProductsOfVariety(variety.vid, 0) : products
    var initialPositionItem = this.getScrolledPositionItem(dataSource, product)
    return [pid, product, vid, variety, dataSource, initialPositionItem]
  }

  getScrolledPositionItem = (dataSource, product) => {
    if (!dataSource || dataSource.length == 0 || !product) {
      return null
    }
    if (dataSource[0].pid == product.pid) {
      return dataSource[0]
    }
    for (var i = 0; i < dataSource.length - 1; i++) {
      if (dataSource[i + 1].pid == product.pid) {
        return dataSource[i]
      }
    }
    return null
  }

  getProductRefs = () => {
    var refs = {}
    if (this.state.dataSource) {
      for (var product of this.state.dataSource) {
        refs[product.pid] = React.createRef()
      }
    }
    return refs
  }

  getProductRefByPid = (pid) => {
    return this.productRefs[pid]
  }

  viewContact = () => {
    this.props.history.push('/contact')
  }

  gotoShop = () => {
    window.open(this.state.product.link, '_blank')
  }
}
